import { Avatar, Box } from "@mui/material";
import { Link } from "@reach/router";
import React from "react";
import notificationUtil from "../../utils/notificationUtil";
import ilocalboxAvatarlogo from "../home/images/ilocalboxlogo.png";
import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';
import TaskTypeEnum from "../taskmanager/taskTypeEnum";

export const TaskNotificationComponent = ({ props }) => {
  const isPickupChangeRequest = props["TaskTypeID"] === TaskTypeEnum.PickupChangeRequest;
  const pickupChangeMessage = props["Status"] === "Cancelled"
    ? "Customer cancelled pickup change request."
    : props["TaskName"] || "Customer requested pickup change.";

  return (
    <Box component="section" {...props}>
      <Link
        to="/home/taskmanager"
        style={{
          textDecoration: "none",
          color: "black",
        }}
      >
        <Box
          component="div"
          sx={[
            {
              backgroundColor: "transparent",
              transition: "background-color 2s ease 0s",
              marginLeft: "-8px",
              marginRight: "-8px",
              marginBottom: "4px",
              borderRadius: "3px",
              p: "5px 0",
              ":hover": {
                background: "#ECEDF0",
              },
            },
          ]}
        >
          <Box sx={{ display: "flex", width: "100%" }}>
            <Box sx={{ mr: "10px", ml: "10px", mt: "2px", display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50%' }}>              
              {(props["Type"] === 'CALL') ? <PhoneMissedIcon sx={{ fontSize:30, width:'1.3em' }} /> : (<Avatar
                alt="UserAvatar"
                src={
                  props["PhotoURL"] ? props["PhotoURL"] : ilocalboxAvatarlogo
                }
              />)}
              {/* <img
                src={props["PhotoURL"]}
                alt="UserProfile"
                height="40"
                width="40"
                style={{ borderRadius: "50%" }} */}
              {/* /> */}
            </Box>
            <Box sx={{ width: "100%" }}>
              <Box
                component="p"
                sx={{
                  fontSize: "13px",
                  fontWeight: "500",
                  lineHeight: "15px",
                  m: 0,
                }}
              >
                {isPickupChangeRequest && pickupChangeMessage}
                {!isPickupChangeRequest && props["Type"] === "CREATE" &&
                  `${props["UserName"] + " assinged task to you."}`}
                {!isPickupChangeRequest && props["Type"] === "UPDATE" &&
                  `${props["UserName"] + " updated task."}`}
                {!isPickupChangeRequest && props["Type"] === "DELETE" &&
                  `${props["UserName"] + " deleted task."}`}
                {!isPickupChangeRequest && props["Type"] === "CALL" &&
                  `${props["UserName"] + " you missed patient call."}`}
                <Box
                  component="span"
                  sx={{
                    fontSize: "10px",
                    fontWeight: "400",
                    whiteSpace: "nowrap",
                    marginLeft: "5px",
                    color: "#6B778C",
                  }}
                >
                  {notificationUtil.timeSince(new Date(props["CreatedOn"]))}
                </Box>
              </Box>
              <Box
                component="p"
                sx={{
                  fontSize: "12px",
                  lineHeight: "14px",
                  m: 0,
                }}
              >
                {props["TaskName"]}
                <Box
                  component="span"
                  sx={{
                    fontSize: "10px",
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                    color: "#6B778C",
                  }}
                >
                  {" • "}
                  {props["Priority"]}
                </Box>
              </Box>
              <Box
                component="p"
                sx={{
                  fontSize: "11px",
                  lineHeight: "14px",
                  m: 0,
                }}
              >
                {props["TaskTypeName"] && props["TaskTypeName"].toUpperCase()}
                <Box
                  component="span"
                  sx={{
                    fontSize: "10px",
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                    color: "#6B778C",
                  }}
                >
                  {" • "}
                  {props["Status"]}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Link>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/TaskNotificationComponent.js